import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { PageName, CONSTANTS, ParentRoute, ParamsType } from '@app/constants';
import { DataService } from '@app/data';

@Component({
  selector: 'app-home',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less']
})
export class HomeComponent /*implements OnInit, OnDestroy*/ {

  public routes$: Observable<ParentRoute[]> = this.data.getRoutes$();
  public queryParams$ = new BehaviorSubject<ParamsType>({});
  private pageName: string = this.data.getCurrentPageName();

  constructor(
    private data: DataService,
  ) {
    //this.pagination$.subscribe(data => console.log('HomeComponent pagination$ data ', data));
  }
}
